/** Wo ein Clip liegt, wenn es ihn noch gibt. */
export function clipFinden(timeline, clipId) {
    for (const track of timeline.tracks) {
        const clip = track.clips.find((c) => c.id === clipId);
        if (clip)
            return { clip, trackId: track.id };
    }
    return null;
}
/**
 * Wohin ein Hinweis zeigt.
 *
 * Hängt er an einem Clip, der noch da ist, zeigt er auf **die Stelle im
 * Clip**, nicht auf dessen Anfang: gesetzt wurde er bei Sekunde x, und wenn
 * der Clip seither verschoben wurde, ist dieselbe Stelle um denselben Betrag
 * mitgewandert. Liegt die gesetzte Sekunde ausserhalb (der Clip wurde
 * gekürzt), bleibt es beim Anfang -- irgendwo muss der Kopf hin, und der
 * Anfang ist die einzige Stelle, die es sicher gibt.
 */
export function hinweisZiel(timeline, hinweis) {
    if (!hinweis.clipId)
        return { at: hinweis.at, clipId: null, label: '', verwaist: false };
    const treffer = clipFinden(timeline, hinweis.clipId);
    if (!treffer)
        return { at: hinweis.at, clipId: null, label: '', verwaist: true };
    const { clip } = treffer;
    const drin = hinweis.at >= clip.start && hinweis.at <= clip.start + clip.duration;
    return {
        at: drin ? hinweis.at : clip.start,
        clipId: clip.id,
        label: clip.label || clip.id,
        verwaist: false,
    };
}
/**
 * Wie viele **offene** Hinweise an jedem Clip hängen -- für die Marke auf der
 * Zeitleiste.
 *
 * Erledigte zählen nicht: eine Zahl, die nie kleiner wird, sagt nach einer
 * Woche nichts mehr. Antworten zählen auch nicht -- sie hängen an ihrem
 * Hinweis und nicht am Clip, sonst stünde an einem Clip mit einem Hinweis und
 * fünf Antworten eine Sechs.
 */
export function offeneJeClip(hinweise) {
    const raus = new Map();
    for (const h of hinweise) {
        if (!h.clipId || h.parentId || h.erledigt)
            continue;
        raus.set(h.clipId, (raus.get(h.clipId) ?? 0) + 1);
    }
    return raus;
}
//# sourceMappingURL=hinweis.js.map